import React from 'react';
import CardTabs from '../../../../shared/ui/CardTabs';
import { useFormWatch } from '../../../../../../helpers/formManager';
import { fieldPathBuilders } from '../../../../shared/configs/acceptanceForm';
import {
  evenOddDays,
  weekDays,
} from '../../../../shared/configs/selectionData/days';
import { scheduleTypeIds } from '../../../../shared/configs/selectionData/scheduleTypes';

const emptyArr = [];
const {
  scheduleType: createScheduleTypeName,
  workingDays: createWorkingDaysName,
} = fieldPathBuilders.desk;

const DayTabs = ({ deskIndex, tabContent }) => {
  const scheduleType = useFormWatch({
    name: createScheduleTypeName(deskIndex),
    exact: true,
  });

  if (!scheduleType) {
    return null;
  }

  return scheduleType === scheduleTypeIds.byWeekDays ? (
    <WeekDaysTabs deskIndex={deskIndex} tabContent={tabContent} />
  ) : (
    <EvenOddDaysTabs deskIndex={deskIndex} tabContent={tabContent} />
  );
};

export default DayTabs;

function BaseTabs({ tabs = emptyArr, deskIndex, tabContent: TabContent }) {
  return (
    <CardTabs tabBarGutter={8} animated>
      {tabs.map(({ key, tab }) => {
        return (
          <CardTabs.TabPane key={key} tab={tab} forceRender>
            <TabContent deskIndex={deskIndex} entityKey={key} />
          </CardTabs.TabPane>
        );
      })}
    </CardTabs>
  );
}

function WeekDaysTabs({ deskIndex, tabContent }) {
  const workingDays = useFormWatch({
    name: createWorkingDaysName(deskIndex),
    exact: true,
    defaultValue: [],
  });

  const tabs = workingDays.map((day) => ({
    key: day,
    tab: weekDays.get(day) || 'Неизвестный день',
  }));

  return <BaseTabs tabs={tabs} deskIndex={deskIndex} tabContent={tabContent} />;
}

const tabs = [...evenOddDays.entries()].map(([key, tab]) => ({ key, tab }));
function EvenOddDaysTabs({ deskIndex, tabContent }) {
  return <BaseTabs tabs={tabs} deskIndex={deskIndex} tabContent={tabContent} />;
}
